<template>
    <div class="create-map card-box">
        <div class="create-map-context">
            <div class="create-map-title">
                <span class="create-map-icon icon-icomoon icon-icomoon-addition"></span>
                <p class="create-map-text">新建</p>
            </div>
            <div class="create-map-option">
                <span class="create-map-new-map" @click="addMap">
                    <img src="data:image/png;base64,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"
                        width="25">新建地图
                </span>
                <p class="create-map-new-folder" @click="addFolder">
                    <img src="@/assets/images/icon/folder.png" width="25">新建文件夹
                </p>
            </div>
        </div>
    </div>
</template>

<script>

import { addAtlas, addFolder } from '@/api/Common';
import { useRouter, useRoute } from 'vue-router';
import { useMapStore } from '@/stores/mapStore';


export default {
    name: 'CreateMap',
    components: {

    },
    data() {
        return {
            router: null,
            mapStore: null,
            userInfo: {},
        }
    },
    props: {
        folder: {
            type: Object, // 假设 item 是对象类型，根据实际情况调整
            required: true // 表示该参数是必需的
        }
    },
    mounted() {
        this.mapStore = useMapStore();
        this.userInfo = this.mapStore.getUserInfo();
        this.router = useRouter();
    },
    methods: {
        addMap() {
            let that = this;
            addAtlas({ userId: this.userInfo.userId, name: "未命名", folderId: this.folder.id, }).then(res => {
                alert(res.msg);
                if (res.code == 200) {
                    that.$emit('map-refresh');
                }
            })
        },
        addFolder() {
            let that = this;
            addFolder({ userId: this.userInfo.userId, fileName: "未命名", pid: this.folder.id }).then(res => {
                alert(res.msg);
                if (res.code == 200) {
                    that.$emit('map-refresh');
                }
            })
        }

    }
}

</script>

<style scoped>
.create-map:hover .create-map-option {
    display: block;
}

.create-map:hover .create-map-title {
    display: none;
}


.create-map-context {
    border: 1px dashed #707e91;
    margin: 14px;
    height: 170px;
}


.create-map-title {
    margin-top: 64px;
    text-align: center;
}

.create-map-icon {
    font-size: 28px;

}

.create-map-text {
    margin-top: 8px;
}


.create-map-option {
    margin-top: 64px;
    text-align: center;
    display: none;
}

.create-map-option img {
    position: relative;
    top: -3px;
    margin-right: 10px;
}

.create-map-new-map {
    margin-left: -15px;
    cursor: pointer;
}

.create-map-new-folder {
    margin-top: 10px;
    cursor: pointer;
}

@media screen and (min-width: 1680px) {

    .create-map-context {
        height: 230px;
    }

    .create-map-title,
    .create-map-option {
        margin-top: 84px;
    }
}

@media screen and (min-width: 1920px) {

    .create-map-context {
        height: 250px;
    }

    .create-map-title,
    .create-map-option {
        margin-top: 96px;
    }
}
</style>